<template>
  <span class="expand-content-control">
    <button v-if="collapsed" type="button" class="btn btn-link" @click="expand">
      {{ i18n.t('expand') }}
      <i class="icon-angle-down" />
    </button>
    <button v-else type="button" class="btn btn-link" @click="collapse">
      {{ i18n.t('buttons.collapse') }}
      <i class="icon-angle-up" />
    </button>
  </span>
</template>

<script>
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: true
    }
  },

  emits: ['collapse', 'expand'],

  methods: {
    expand() {
      this.$emit('expand')
    },
    collapse() {
      this.$emit('collapse')
    }
  }
}
</script>

<style scoped lang="scss">
  button.btn-link {
    padding: 0;
  }
</style>
